import React from "react";
import ct from "class-types.macro";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import Stars from "~/common/Stars";
import CrossedOutPrice from "~/productListing/ProductBox/Pricing/CrossedOutPrice";
import StandardPrice from "~/productListing/ProductBox/Pricing/Price";
import Ribbon from "~/productListing/ProductBox/Ribbon";

interface Props {
  link: string;
  description: string;
  primaryImagePath: string;
  oneToFiveStarRating: number;
  isWebstaurantPlusEligible: boolean;
  price: {
    displaySalePrice: boolean;
    price: number;
    originalPrice?: number;
    salePrice: number;
  };
  unitOfMeasure: string;
  isOutlet: boolean;
}

const CarouselMemberProduct = ({
  link,
  description,
  primaryImagePath,
  oneToFiveStarRating,
  isWebstaurantPlusEligible,
  price,
  unitOfMeasure,
  isOutlet,
}: Props) => {
  return (
    <>
      <div
        className={ct(
          "hover:outline-gray-200",
          "border-white",
          "border-solid",
          "border-6",
          "m-0",
          "max-w-full",
          "overflow-hidden",
          "relative",
        )}
      >
        <div className={ct("h-0", "pb-full")}>
          <a href={link} title={description} className={ct("block")}>
            <NoScriptLazyImage
              alt={description}
              src={primaryImagePath}
              className={ct("absolute", "inset-0", "w-full")}
              data-src={primaryImagePath}
            />
          </a>
        </div>
      </div>

      <div
        className={ct(
          "block",
          "text-center",
          oneToFiveStarRating === 0 && !isWebstaurantPlusEligible
            ? ct("mt-2")
            : "",
          oneToFiveStarRating === 0 && isWebstaurantPlusEligible
            ? ct("mt-1")
            : "",
        )}
      >
        {isWebstaurantPlusEligible && (
          <Ribbon
            bgcolor="lightBlue"
            href="/plus/"
            data-testid="itemPlus"
            className={ct("inline-block", "mx-1", "italic")}
          >
            plus
          </Ribbon>
        )}
        <div className={ct("inline-block", "mt-1")}>
          <Stars rating={oneToFiveStarRating} />
        </div>
        <a
          href={link}
          className={ct(
            "block",
            "font-semibold",
            "text-sm-1/2",
            "leading-none",
            "my-2-1/2",
            "max-h-10",
            "min-h-10",
            "overflow-hidden",
          )}
        >
          {description}
        </a>
      </div>

      <div
        className={ct(
          "flex",
          "flex-col",
          "justify-center",
          "flex-auto",
          "mt-0",
          "mb-4",
          "relative",
          "text-center",
          "xsl:flex-col",
          "lt:mt-0",
        )}
      >
        <StandardPrice
          price={price.salePrice > 0 ? price.salePrice : price.price}
          unitOfMeasure={unitOfMeasure}
          isOutlet={isOutlet}
          textSize="custom"
          className={ct("text-lg")}
        />

        {price.displaySalePrice && (
          <CrossedOutPrice
            price={price.price}
            originalPrice={price.originalPrice}
            showOriginalOutletPrice={isOutlet}
          />
        )}
      </div>
    </>
  );
};

export default CarouselMemberProduct;
